<template>
    <MainContainer>
        <b-row align-h="center">
            <b-col cols="4">
                <div class="mv-login mt-5 px-5 py-3">
                    <h5 class="text-center mb-3">Passwort zurücksetzen</h5>
                    <img src="../assets/images/mv_logo_trans.png" class="logo mx-auto mb-4" />
                    <b-form @submit="onSubmit">
                        <b-form-group
                            id="usernameInputGroup"
                            label="ID / Benutzename / E-Mail:"
                            label-for="identifierInput"
                            description="Ihr Benutzername entspricht normalerweise dem Ihres Wordpress Accounts, alternativ kann aber auch die Mitglieds-ID oder E-Mail Adresse verwendet werden"
                        >
                            <b-form-input
                                id="identifierInput"
                                type="text"
                                v-model="form.identifier"
                                required
                                placeholder="ID / Benutzename / E-Mail eingeben"
                            ></b-form-input>
                        </b-form-group>
                        <p class="text-success my-1">
                            <template v-if="answer !== ''">
                                <hr />
                                {{this.answer}}
                                <hr />
                            </template>
                        </p>
                        <b-button
                            type="submit"
                            variant="primary"
                            block
                            class="mt-3"
                            :disabled="busy || answer !== ''"
                        >
                            <template v-if="busy">
                                <Spinner :small="true" class="mr-1" variant="light" />
                            </template>Password zurücksetzen
                        </b-button>
                        <b-button variant="link" to="/" block>Zurück</b-button>
                    </b-form>
                </div>
            </b-col>
        </b-row>
    </MainContainer>
</template>

<script>
import { ApiFactory } from "@/api/ApiFactory";
import MainContainer from "@/components/MainContainer/MainContainer";
import Spinner from "@/components/Spinner/Spinner";

const BenutzerverwaltungsApi = ApiFactory.get("benutzerverwaltung");

export default {
    name: "forget-password",
    components: {
        MainContainer,
        Spinner
    },
    data() {
        return {
            form: {
                identifier: ""
            },
            answer: "",
            busy: false
        };
    },
    methods: {
        async onSubmit(evt) {
            evt.preventDefault();
            this.busy = true;
            const response = await BenutzerverwaltungsApi.resetPassword(
                this.form.identifier
            );
            if (response.ok) {
                this.answer =
                    "Ihr Passwort wurde erfolgreich zurückgesetzt. Bitte prüfen Sie Ihr E-Mail Postfach und folgen Sie den Instruktionen in der Mail.";
            }
            this.busy = false;
        }
    }
};
</script>